import {
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

export default function PasswordInput({
  password,
  setPassword,
  placeholder = 'Password',
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputGroup size='lg'>
      <Input
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <InputRightElement>
        <IconButton
          icon={showPassword ? <FiEyeOff /> : <FiEye />}
          variant='ghost'
          onClick={() => setShowPassword(showPassword => !showPassword)}
          aria-label='Toggle Password Visibility'
        />
      </InputRightElement>
    </InputGroup>
  );
}
